import { render, staticRenderFns } from "./btn-inline-primary.mpx?vue&type=template&id=4e153862&isComponent&outputPath=components%2Fbtn-inline-primary1655f572%2Findex"
import script from "./btn-inline-primary.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-inline-primary1655f572%2Findex"
export * from "./btn-inline-primary.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-inline-primary1655f572%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports